(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

window.addEventListener("load", function () {
  var verifyTransactionOnBackend = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(transactionID) {
      var data, formData, key, params;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              paymentForm.querySelector(".js-form-submission").classList.add("show");

              data = {
                action: "realmuloodi_verify_transaction",
                transactionID: transactionID
              };

              // convert data to form data

              formData = new FormData();

              for (key in data) {
                formData.append(key, data[key]);
              }

              params = new URLSearchParams(formData);
              _context2.next = 7;
              return fetch(paymentForm.dataset.url, {
                method: "POST",
                body: params
              }).then(function (response) {
                return response.json();
              }).catch(function (error) {
                resetMessages();

                window.verified = false;
              }).then(function (response) {
                resetMessages();
                window.verified = true;
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function verifyTransactionOnBackend(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var paymentForm = document.querySelector("#realmuloodi-payment-form");
  window.verified = false;

  if (!paymentForm) return;

  paymentForm.addEventListener("submit", handleOnRegistration);

  function handleOnRegistration(event) {
    event.preventDefault();
    // Flutterwave integration
    if (!realmuloodi.flutterwave) return;

    resetMessages();

    var _realmuloodi$flutterw = realmuloodi.flutterwave,
        public_key = _realmuloodi$flutterw.public_key,
        tx_ref = _realmuloodi$flutterw.tx_ref,
        amount = _realmuloodi$flutterw.amount,
        currency = _realmuloodi$flutterw.currency,
        country = _realmuloodi$flutterw.country,
        payment_options = _realmuloodi$flutterw.payment_options,
        customer = _realmuloodi$flutterw.customer,
        customizations = _realmuloodi$flutterw.customizations;

    // initialize the flutterwave payment

    FlutterwaveCheckout({
      public_key: public_key,
      tx_ref: tx_ref,
      amount: amount,
      currency: currency,
      country: country,
      payment_options: payment_options,
      callback: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payment) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return verifyTransactionOnBackend(payment.transaction_id);

                case 2:
                  window.location.href = "/dashboard-main";

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function callback(_x) {
          return _ref.apply(this, arguments);
        }

        return callback;
      }(),
      onclose: function onclose(incomplete) {
        if (incomplete || window.verified === false) {
          paymentForm.querySelector(".js-form-error").classList.add("show");
        } else {
          if (window.verified == true) {
            paymentForm.querySelector(".js-form-success").classList.add("show");
          } else {
            paymentForm.querySelector(".js-form-submission").classList.add("show");
          }
        }
      },
      customer: {
        email: customer.email
      },
      customizations: {
        title: customizations.title,
        description: customizations.description,
        logo: customizations.logo
      }
    });
  }
});

function resetMessages() {
  document.querySelectorAll(".field-message").forEach(function (el) {
    return el.classList.remove("show");
  });
}

},{}]},{},[1]);
